import { render, staticRenderFns } from "./SyncIndex.vue?vue&type=template&id=2571cc61&scoped=true"
import script from "./SyncIndex.vue?vue&type=script&lang=js"
export * from "./SyncIndex.vue?vue&type=script&lang=js"
import style0 from "./SyncIndex.vue?vue&type=style&index=0&id=2571cc61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2571cc61",
  null
  
)

export default component.exports